// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.save-as-template label{font-weight:normal}`, "",{"version":3,"sources":["webpack://./src/react/components/jobs/SaveAsTemplateModal/SaveAsTemplate.css"],"names":[],"mappings":"AAAA,wBACE,kBAAA","sourcesContent":[".save-as-template label {\n  font-weight: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
